export default {
  header: 'Enable cookies',
  subHeader: 'We use cookies to enhance your browsing experience.',
  policyLink: 'Cookie Policy',
  acceptButton: 'Accept cookies',
};
